module.exports = __webpack_public_path__ + "static/media/3-books-shelf.daa65115.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/photographs/3-books-shelf.png
 ** module id = 255
 ** module chunks = 0
 **/